const MAX_TRANSCRIPT_LENGTH = 400;
export function removeHtmlCharacters(s) {
    const htmlToCharacterMap = new Map();
    htmlToCharacterMap.set('&amp;#39;', "'");

    let s1 = s;
    htmlToCharacterMap.forEach((value, key, map) => {
        s1 = s1.replaceAll(key, value);
    });

    return new String(s1);
}

export function merge(transcripts) {
    if (!transcripts) {
        return transcripts;
    }
    if (transcripts && transcripts.size < MAX_TRANSCRIPT_LENGTH) {
        return transcripts;
    }

    const k = Math.ceil(transcripts.length / MAX_TRANSCRIPT_LENGTH);

    const mergedTranscripts = [];
    let i = 0;
    while (i < transcripts.length) {
        let s = "";
        let j = 0;
        const t = transcripts[i];
        let duration = transcripts[i].duration;
        while (i + j < transcripts.length && j < k) {
            s += removeHtmlCharacters(transcripts[i + j].text) + " ";
            duration += transcripts[i + j].duration;
            j++;
        }
        i = i + j;
        mergedTranscripts.push({
            duration: duration,
            text: s,
            offset: t.offset,
            lang: t.lang
        });
        
    }
    return mergedTranscripts;
}